import dimorderApi from '@/libs/api/dimorderApi'
import checkCRMPermission from '@/libs/checkCRMPermission'

const maxConcurrentMerchants = 5

export default async function checkCRMEligibility(merchants, isAdmin) {
  if (!merchants.length) return false

  const results = new Array(merchants.length)
  let nextIndex = 0
  await Promise.all(
    Array.from({ length: Math.min(maxConcurrentMerchants, merchants.length) }, async () => {
      while (nextIndex < merchants.length) {
        const index = nextIndex++
        const merchant = merchants[index]
        try {
          const hasPermission =
            isAdmin || (await checkCRMPermission(merchant.id, merchant.username))
          if (!hasPermission) continue

          results[index] = await dimorderApi.instance(merchant.id)?.checkCRMAvailability()
        } catch (error) {
          if (![403, 410].includes(error?.response?.status)) {
            console.error('checkCRMEligibility error', merchant.id, error)
          }
        }
      }
    }),
  )
  return results.some(Boolean)
}
